import { pxToRem } from '../../utils';
import { mapColorsToScheme } from '../../../../lib';
export default (function (siteVars) {
    var colorVariant = 500;
    return {
        colors: mapColorsToScheme(siteVars, colorVariant),
        dividerColor: siteVars.gray09,
        textColor: siteVars.gray03,
        textFontSize: siteVars.fontSizeSmall,
        textLineHeight: siteVars.lineHeightSmall,
        importantFontWeight: siteVars.fontWeightBold,
        dividerPadding: pxToRem(4),
    };
});
